import { JournalArticle, articlePath, journalDescription, journalName } from './content';
import { siteOrigin, socialImage } from '../../seo/site';
export { siteOrigin } from '../../seo/site';
export function journalMetadata(article?: JournalArticle) {
  const canonicalUrl = siteOrigin + (article ? articlePath(article) : '/journal');
  const image = socialImage;
  const title = article ? `${article.seoTitle} | ${journalName}` : `${journalName} | Tarot, Healing & Rituals`;
  const description = article?.description || journalDescription;
  const breadcrumb = { '@type': 'BreadcrumbList', itemListElement: [
    { '@type':'ListItem', position:1, name:'Home', item:siteOrigin+'/' },
    { '@type':'ListItem', position:2, name:journalName, item:siteOrigin+'/journal' },
    ...(article ? [{ '@type':'ListItem', position:3, name:article.title, item:canonicalUrl }] : [])
  ] };
  const schema = { '@context':'https://schema.org', '@graph': [breadcrumb, article ? {
    '@type':'BlogPosting', '@id':canonicalUrl+'#article', mainEntityOfPage:canonicalUrl,
    headline:article.title, description, image:[image], datePublished:article.date+'T00:00:00+05:30', dateModified:article.date+'T00:00:00+05:30',
    author:{'@type':'Organization',name:'Radian Soul',url:siteOrigin+'/about'},
    publisher:{'@type':'Organization',name:'Radian Soul',url:siteOrigin,logo:{'@type':'ImageObject',url:siteOrigin+'/logo.png'}},
    articleSection:article.category, inLanguage:'en-IN', isPartOf:{'@type':'Blog',name:journalName,url:siteOrigin+'/journal'},
    citation:article.sources.map(source=>source.url)
  } : { '@type':'Blog', name:journalName, url:canonicalUrl, description, publisher:{'@type':'Organization',name:'Radian Soul',url:siteOrigin} }] };
  return {title, description, canonicalUrl, image, type: article ? 'article' : 'website', publishedTime:article ? article.date+'T00:00:00+05:30' : undefined, schema};
}
